"use client";

import { c as _c } from "react/compiler-runtime";
import { propertyTypeOptions } from "@/info/unit/property-types";
import { cn } from "@/utils/cn";
import { Text } from "react-aria-components";
import type { PropertyType } from "../search/filters/desktop";
interface PropertyTypeOption {
  label: string;
  value: string;
  icon: React.ComponentType<{
    className?: string;
  }>;
}
interface PropertyTypeIconGridProps {
  value: PropertyType;
  onChange: (value: string | null) => void;
  required?: boolean;
  description?: string;
  errorMessage?: string;
  options: PropertyTypeOption[];
}
export function PropertyTypeIconGrid(t0) {
  const $ = _c(18);
  const {
    value,
    onChange,
    description,
    errorMessage,
    options: t1
  } = t0;
  const options = t1 === undefined ? propertyTypeOptions : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("group flex flex-col gap-2");
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== onChange || $[2] !== options || $[3] !== value) {
    let t4;
    if ($[5] !== onChange || $[6] !== value) {
      t4 = type => {
        const Icon = type.icon;
        const isSelected = value === type.value;
        return <button type="button" key={type.value} aria-pressed={isSelected} onClick={() => {
          const newValue = isSelected ? null : type.value;
          onChange(newValue);
        }} className="flex flex-col items-center gap-2 text-center focus:outline-none"><div aria-hidden="true" className={cn("w-14 h-14 rounded-xl border-2 flex items-center justify-center transition-colors cursor-pointer", isSelected ? "border-primary bg-pink-50" : "border-gray-300 bg-gray-100 hover:border-gray-400 hover:bg-gray-200")}><Icon className={cn("w-7 h-7 transition-colors", isSelected ? "text-primary-600" : "text-body")} /></div><span className={cn("text-sm font-medium transition-colors", isSelected ? "text-primary-600" : "text-body")}>{type.label}</span></button>;
      };
      $[5] = onChange;
      $[6] = value;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    t3 = options.map(t4);
    $[1] = onChange;
    $[2] = options;
    $[3] = value;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <div className="grid grid-cols-4 gap-4" role="group" aria-label="Property type selection">{t3}</div>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== description) {
    t5 = description && <Text slot="description" className="text-body-small">{description}</Text>;
    $[10] = description;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = errorMessage || "";
  let t7;
  if ($[12] !== t6) {
    t7 = <Text slot="errorMessage" className="text-body-small-medium text-destructive h-1">{t6}</Text>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t4 || $[15] !== t5 || $[16] !== t7) {
    t8 = <div className={t2}>{t4}{t5}{t7}</div>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}